<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'materialArticle',
})
</script>
<template>
  <router-view v-if="$route.name !== 'materialArticle'" v-slot="{ Component }">
    <component :is="Component" :key="$route.fullPath" />
  </router-view>
  <div v-else>
    <a-card>
      <div class="material-article-search">
        <a-form :model="state.tableData.param" class="global-search-form">
          <a-row :gutter="24">
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6" class="mb-[10px]">
              <a-form-item label="标题">
                <a-input v-model:value="state.tableData.param.title" placeholder="请输入标题" :maxlength="100" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6" class="mb-[10px]">
              <a-form-item label="店铺类型">
                <a-select v-model:value="state.tableData.param.storeTypeCode" placeholder="请选择店铺类型" allow-clear>
                  <a-select-option v-for="item in storeTypeList" :key="item.code" :value="item.code">{{ item.name
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <!-- <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6" class="mb-[10px]">
              <a-form-item label="分类">
                <a-select v-model:value="state.tableData.param.categoryCode" placeholder="请选择分类" allow-clear>
                  <a-select-option v-for="item in categoryList" :key="item.code" :value="item.code">{{ item.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col> -->
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6" class="mb-[10px]">
              <div class="card-col-action btn-group">
                <ant-button class="search mr-[10px]!" @click="getTableData" type="primary">
                  <SearchOutlined />查询
                </ant-button>
                <ant-button class="resetFun mr-[10px]!" @click="resetFun" type="primary">
                  <RedoOutlined />重置
                </ant-button>
              </div>
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6" class="mb-[10px]">
              <div class="card-col-action btn-group justify-start md:justify-end">
                <ant-button class="add" @click="router.push({ path: '/material/article/form' })" type="primary"
                  v-auth="'article.add'">
                  <PlusOutlined />新增文章
                </ant-button>
              </div>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <ant-table :columns="columns" :data-source="state.tableData.data" :loading="state.tableData.loading"
        :pagination="false" row-key="id">
        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'action'">
            <div class="table-action-left">
              <!-- <a-button type="link" size="small"
                @click="router.push({ name: 'materialArticleDetail', params: { id: record.id } })">查看</a-button> -->
              <a-button type="link" size="small"
                @click="router.push({ name: 'materialArticleEdit', params: { id: record.id } })"
                v-auth="'article.edit'">编辑</a-button>
              <a-button type="link" size="small" danger @click="onDelete(record)" v-auth="'article.del'">删除</a-button>
            </div>
          </template>
        </template>
      </ant-table>
      <ant-pagination v-model:current="state.tableData.param.pageNum" v-model:page-size="state.tableData.param.pageSize"
        :total="state.tableData.total" :page-size-options="['10', '20']" show-size-changer
        :show-total="(total) => `共 ${total} 条`" :showQuickJumper="true" @change="onPageChange"
        @show-size-change="onShowSizeChange" />
    </a-card>
  </div>
</template>

<script setup lang="ts" name="materialArticle">
import { reactive, ref, onMounted, h, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { message, Modal } from 'ant-design-vue'
import { SearchOutlined, RedoOutlined, PlusOutlined, ExclamationCircleOutlined } from '@ant-design/icons-vue'
import { useMaterialArticle } from '@/store/material/article'
import { useDictionary } from '@/store/system/dictionary'
import { fetchWithPaginationFallback } from '@/utils/paginationFallback'

const router = useRouter()
const route = useRoute()
const articleStore = useMaterialArticle()
const dictionaryStore = useDictionary()

const columns = [
  { title: '序号', key: 'index', width: 80, customRender: ({ index }: { index: number }) => index + 1 },
  { title: '店铺类型', dataIndex: 'storeTypeStr', key: 'storeTypeStr', ellipsis: true },
  { title: '分类', dataIndex: 'categoryStr', key: 'categoryStr', ellipsis: true },

  { title: '标题', dataIndex: 'title', key: 'title', ellipsis: true },
  { title: '关键词', dataIndex: 'keyword', key: 'keyword', ellipsis: true },
  //{ title: '排序', dataIndex: 'sortOrder', key: 'sortOrder', width: 80 },
  { title: '点击次数', dataIndex: 'clickCount', key: 'clickCount', width: 100 },
  { title: '点击人数', dataIndex: 'clickUserCount', key: 'clickUserCount', width: 100 },
  { title: '更新时间', dataIndex: 'createTime', key: 'createTime', minWidth: 160, ellipsis: true },
  { title: '操作', key: 'action', width: 200 }
]

const state = reactive({
  tableData: {
    data: [] as any[],
    total: 0,
    loading: false,
    param: {
      pageNum: 1,
      pageSize: 10,
      title: '',
      storeTypeCode: undefined as string | undefined,
      categoryCode: undefined as string | undefined
    }
  }
})

const storeTypeList = ref<any[]>([])
const categoryList = ref<any[]>([])

const getCategoryList = async () => {
  try {
    const data: any = await dictionaryStore.getDict({ code: 'article_category' })
    categoryList.value = data || []
    return data || []
  } catch (err) {
    console.error('获取分类字典失败', err)
    categoryList.value = []
    return []
  }
}

const resetFun = () => {
  state.tableData.param.title = ''
  state.tableData.param.storeTypeCode = undefined
  state.tableData.param.categoryCode = undefined
  state.tableData.param.pageNum = 1
}

const getTableData = async () => {
  state.tableData.loading = true
  try {
    const data: any = await fetchWithPaginationFallback(
      (param) => articleStore.getArticlePage(param),
      state.tableData.param
    )
    state.tableData.data = data.records || []
    state.tableData.total = data.total || 0
    state.tableData.param.pageNum = data.pageNum ?? state.tableData.param.pageNum
  } finally {
    setTimeout(() => {
      state.tableData.loading = false
    }, 500)
  }
}

const onDelete = (row: any) => {
  Modal.confirm({
    transitionName: '',
    title: '提示',
    icon: () => h(ExclamationCircleOutlined),
    centered: true,
    content: `此操作将永久删除文章："${row.title}"，是否继续?`,
    okText: '确认',
    cancelText: '取消',
    onOk: () => {
      return articleStore.deleteArticle(row.id).then(() => {
        message.success('删除成功')
        getTableData()
      })
    }
  })
}

const onPageChange = (page: number) => {
  state.tableData.param.pageNum = page
  getTableData()
}

const onShowSizeChange = (_current: number, size: number) => {
  state.tableData.param.pageSize = size
  state.tableData.param.pageNum = 1
  getTableData()
}

const getStoreTypeList = async () => {
  try {
    const data: any = await dictionaryStore.getDict({ code: 'store_type' })
    storeTypeList.value = data || []
  } catch (err) {
    console.error('获取店铺类型失败', err)
    storeTypeList.value = []
  }
}

const init = async () => {
  await getStoreTypeList()
  getCategoryList()
  getTableData()
}

watch(
  () => route.name,
  (name) => {
    if (name === 'materialArticle') {
      getTableData()
    }
  }
)

onMounted(() => {
  init()
})
</script>

<style scoped lang="less">
.ml10 {
  margin-left: 10px;
}

.mb20 {
  margin-bottom: 20px;
}

.mt15 {
  margin-top: 15px;
}

.btn-group {
  display: flex;
  white-space: nowrap;
}
</style>
